
<div class="traveller-container">
    <div class="traveller-identity traveller-column">
        <sector-traveller [travellerData]="travellerData"></sector-traveller>
    </div>
    <loader class="traveller-column" *ngIf="isEnumLoading" [message]="labels.enumOnLoad" type="inline"></loader>
    <div class="ticket-seat traveller-column" *ngIf="!isEnumLoading">
        <div class="ticket" *ngIf="travellerDetail.ticket || travellerDetail.ticketNumber">
            <fa-icon [icon]="iconTicket"></fa-icon>
            <strong *ngIf="travellerDetail.ticketNumber">{{ travellerDetail.ticketNumber }}</strong> <em *ngIf="travellerDetail.ticket">{{ travellerDetail.ticket }}</em>

        </div>
        <div class="seat" *ngIf="travellerDetail.seat || travellerDetail.seatNumber">
            <fa-icon [icon]="iconMapMarker"></fa-icon>
            <strong *ngIf="travellerDetail.seatNumber">{{ travellerDetail.seatNumber }}</strong> <em *ngIf="travellerDetail.seat">{{ travellerDetail.seat }}</em>
        </div>
        
    </div>
    <div class="luggage-mealplan-services traveller-column" *ngIf="!isEnumLoading"
        [class.undefined-data]="!travellerDetail.luggage && !travellerDetail.luggageRule">

        <luggage *ngFor="let condition of travellerDetail.luggageRule"
            [restriction]="condition.restriction"
            [type]="condition.in"></luggage>

        <div class="mealplan-services"
            *ngIf="travellerDetail.mealplan">
            <i class="fa fa-cutlery"></i>
            <fa-icon [icon]="iconCoffee"></fa-icon>
            <em>{{ travellerDetail.mealplan }}</em>
        </div>
        
    </div>
</div>
<div class="payable-service traveller-column" *ngIf="travellerDetail.payableService && !isEnumLoading">
    <fa-icon [icon]="iconCreditCard"></fa-icon>
    {{ travellerDetail.payableService }}
</div>